
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1463.15 1113.31"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M1299.9 0l163.25 163.23L987.8 638.61 824.54 475.36z","fill":"#ed412d"}}),_c('path',{attrs:{"d":"M895.41 404.5l163.26 163.26-382.3 382.3-163.25-163.23z","fill":"#4285f4"}}),_c('path',{attrs:{"d":"M513.1 786.8l163.25 163.26-163.25 163.25-163.26-163.25z","fill":"#f3bb12"}}),_c('path',{attrs:{"d":"M0 600.21L163.25 437l361.51 361.47L361.5 961.72z","fill":"#2da94f"}})])])])
          )
        }
      }
    